// extracted by css-extract-rspack-plugin
export default {"repassword":"repassword-vOGX_h"};// extracted by css-extract-rspack-plugin
export default {"repassword":"repassword-vOGX_h"};